<template>
    <div class="p-2">
        <div class="form-group d-flex">
            <label class='col-4'>{{ $t('translations.title')}}:</label><div class='col-20'>{{$parent.item.title}}</div>
        </div>

        <template v-if='is_network_admin()'>
            <div class="form-group d-flex">
                <label class='col-4'>{{ $t('translations.scope')}}:</label><div class='col-20' v-text="($parent.item.provider_id ? $parent.item.provider.name : $t('translations.global'))"></div>
            </div>
        </template>

        <template v-if='!is_network_admin()'>
            <div class="form-group d-flex">
                <label class='col-4'>{{ $t('translations.scope')}}:</label><div class='col-20' v-text="($parent.item.user_id ? $t('translations.personal') : $t('translations.organisational'))"></div>
            </div>
            <div class="form-group d-flex" v-if="$parent.item.user_id">
                <label class='col-4'>{{ $t('translations.all_providers') | capitalise }}:</label><div class='col-20' v-text="$parent.item.provider ? 'No' : 'Yes'"></div>
            </div>
        </template>

        

        <div v-if='has_record_system_integration()' class="form-group d-flex">
            <label class="col-4">{{ $t('translations.codes')}}: </label>
            <div class="col-20 pl-3"><coding-list :value='$parent.item.preset_message_code' :editable='false' /></div>
        </div>

        <div class="form-group d-flex">
            <label class='col-4'>{{ $t('translations.content')}}:</label><div class='col-20' v-html='formatContent($parent.item.content, true)'></div>
        </div>

        <template v-if='!is_network_admin() && $parent.item.user_id != $root.user.id'>
            <div class="alert alert-info" v-if='!$parent.item.provider_id'>
                {{ autobrand('translations.alert_scope_global')}}
            </div>
            <div class="alert alert-info" v-else>
                {{ $t('translations.alert_scope_organisational')}}
            </div>

        </template>
    </div>
</template>

<script>
	export default {
        methods: {
            getName() {
				return this.$parent.item.title;
			},
        }
    }
</script>
